import { injectReducer } from "store/reducers";
import AdminEducatorCenterV2Children from "../../routes/AdminEducatorCenterV2Children";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

export default store => ({
  path: "school-policies",
  isAccountEntry: true,
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(
        /* webpackChunkName: "account-school-policies" */ "../../components"
      ),
      import(
        /* webpackChunkName: "account-school-policies" */ "../../modules/AdminEducatorCenterV2Module"
      ),
    ]).then(([importedModule0, importedModule1]) => {
      const component = importedModule0.default;
      const reducer = importedModule1.default;
      injectReducer(store, {
        key: "adminEducatorCenterV2",
        reducer,
      });
      return component;
    })
  ),
  childRoutes: [AdminEducatorCenterV2Children(store)],
});
